import { baseUrl } from "../airport/apis";

export const holdDetailsUrl = `${baseUrl}/trans/hold_details`;
export const holdBookingUrl = `${baseUrl}/trans/hold/`;

export const ofcAppendUrl = `${baseUrl}/ofc`;
export const queryOfcUrl = `${baseUrl}/ofc/query`;
